export enum OrderTypes {
    provision = 'Provision',
    bonded = 'Bonded',
    nonFood = 'Nonfood',
    season = 'Season', 
    cash = 'Cash',
}